module.exports = __webpack_public_path__ + "static/media/MenuX-Black-Font-logo.5174c7c3.svg";